import { loadGTM } from '../lib/funnels/functions/v1/default/gtm'
import { loadSentry } from '../lib/funnels/functions/v1/default/loadSentry'

// @ts-ignore
const env = import.meta.env
const VITE_SENTRY_DSN = env.VITE_SENTRY_DSN || ''

loadSentry(VITE_SENTRY_DSN)

window.addEventListener('load', () => {
  // @ts-ignore
  window.Trustpilot?.loadFromElement(
    document.getElementById('trustpilot-grid'),
    true,
  )

  loadGTM('GTM-KZ525569')
})
